import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Stack,
    IconButton // Asegúrate de importar el botón
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { CheckCircle, Cancel } from '@mui/icons-material';

import { get, map, isEmpty } from "lodash";

import CircularProgress from "./CircularProgress";
import Empty from "../../assets/icons/Empty";

const TableComponent = ({
    headTable,
    dataTable,
    __,
    loading,
    toolbar,
    propsTable = {},
    propsContainer = {},
    propsTableCell = {},
    action = <></>,
    empty = ""
}) => {
    // Estado para controlar qué fila está expandida
    const [expandedRow, setExpandedRow] = useState(null);

    // Función para manejar el clic en el botón de la fila
    const handleExpandClick = (row) => {
        setExpandedRow(expandedRow === row ? null : row);
    };

    return (
        <Paper>
            {toolbar}
            <TableContainer {...propsContainer}>
                <Table aria-label="table" {...propsTable}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" > Detalle </TableCell> {/* Celda vacía para el botón */}
                            {map(headTable, ({ key, label, align, sx = {} }, i) => (
                                <TableCell key={i} align={align} {...propsTableCell} sx={sx}>
                                    <Typography variant="buttonSmall" component="div">{label}</Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {!loading && (
                        <TableBody>
                            {dataTable.map((row, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell align="center">
                                                <IconButton onClick={() => handleExpandClick(row)}>
                                                    {expandedRow === row ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                            {map(headTable, ({ key, align, sx = {} }, j) => (
                                                <TableCell key={j} align={align} {...propsTableCell} sx={sx}>
                                                    <Typography variant="bodySmall" component="div">
                                                        {get(row, key)}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                        {expandedRow === row && (
                                            <TableRow>
                                                <TableCell colSpan={headTable.length + 1}>
                                                    <Box>
                                                        <Table>
                                                            <TableHead>
                                                                {row.detail && row.detail.length > 0 && (
                                                                    <TableRow>
                                                                        <TableCell align="center">Campo: </TableCell>
                                                                        <TableCell align="center">Valor Antiguo: </TableCell>
                                                                        <TableCell align="center">Valor Nuevo: </TableCell>
                                                                    </TableRow>
                                                                )}
                                                                {row.detailPermises && row.detailPermises.length > 0 && (
                                                                    <TableRow>
                                                                        <TableCell align="center"  sx={{ width: '200px' }}>Pantalla: </TableCell>
                                                                        <TableCell align="center">Visualizar: </TableCell>
                                                                        <TableCell align="center">Agregar: </TableCell>
                                                                        <TableCell align="center">Actualizar: </TableCell>
                                                                        <TableCell align="center">Eliminar: </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableHead>
                                                            <TableBody>
                                                                {row.servicios && row.servicios.length > 0 ? (
                                                                    row.servicios.map((service, idx) => (
                                                                        <TableRow key={idx}>
                                                                            <TableCell align="center">{service.coD_FACTURA ? service.coD_FACTURA : service.idCost}</TableCell>
                                                                            <TableCell align="center">{service.descripcioN_COD ? service.descripcioN_COD : service.costName}</TableCell>
                                                                            <TableCell align="center">{service.quantity}</TableCell>
                                                                            <TableCell align="center">{`$ ${service.price.toFixed(2)}`}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : row.detail && row.detail.length > 0 ? (
                                                                    row.detail.map((detail, idx) => (
                                                                        <TableRow key={idx}>
                                                                            <TableCell align="center">{detail.field}</TableCell>
                                                                            <TableCell align="center">{detail.oldValue}</TableCell>
                                                                            <TableCell align="center">{detail.newValue}</TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : row.detailPermises && row.detailPermises.length > 0 ? (
                                                                    row.detailPermises.map((permission, idx) => (
                                                                        <TableRow key={idx}>
                                                                            <TableCell align="center"  sx={{ width: '200px' }}>{permission.screen}</TableCell>
                                                                            <TableCell align="center"> {permission.watch ? ( <CheckCircle sx={{ color: 'green' }} /> ) : ( <Cancel sx={{ color: 'red' }} /> )} </TableCell>
                                                                            <TableCell align="center"> {permission.add ? ( <CheckCircle sx={{ color: 'green' }} /> ) : ( <Cancel sx={{ color: 'red' }} /> )} </TableCell>
                                                                            <TableCell align="center"> {permission.update ? ( <CheckCircle sx={{ color: 'green' }} /> ) : ( <Cancel sx={{ color: 'red' }} /> )} </TableCell>
                                                                            <TableCell align="center"> {permission.delete ? ( <CheckCircle sx={{ color: 'green' }} /> ) : ( <Cancel sx={{ color: 'red' }} /> )} </TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>No hay información.</TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )}

                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    )}
                </Table>
                {loading && (
                    <Box sx={{
                        display: 'flex',
                        height: 300,
                        width: '100%',
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <CircularProgress />
                    </Box>
                )}
                {(isEmpty(dataTable) && !loading) && (
                    <Box sx={{
                        display: 'flex',
                        flexDirection: "column",
                        height: 500,
                        width: '100%',
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <Empty />
                        {!!empty
                            ? (
                                <Stack justifyContent="center" alignItems="center" spacing={1} pt={2}>
                                    <Typography variant="bml">{__(`table.empty.${empty}.name`)}</Typography>
                                    <Typography variant="caption">{__(`table.empty.${empty}.info`)}</Typography>
                                    <Box pt={2}>
                                        {action}
                                    </Box>
                                </Stack>
                            ) : (
                                <Stack justifyContent="center" alignItems="center" spacing={1} pt={2}>
                                    <Typography variant="bml">{__(`tableDetail.empty.name`)}</Typography>
                                    <Typography variant="caption">{__(`tableDetail.empty.info`)}</Typography>
                                    <Box pt={2}>
                                        {action}
                                    </Box>
                                </Stack>
                            )}
                    </Box>
                )}
            </TableContainer>
        </Paper>
    );
};

export default TableComponent;
